import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaChartBar, FaChevronLeft, FaChevronRight, FaBookOpen, FaGraduationCap } from "react-icons/fa";
import { Settings, LogOut } from "lucide-react";
import { API_BASE } from "./config";
import logo from './deadringers.webp';

function Dashboard({ token, userEmail, company_id, role, onLogout, client_name, director, state, cx }) {
  const navigate = useNavigate();
  const [dashboardLinks, setDashboardLinks] = useState([]);
  const [selectedDashboardUrl, setSelectedDashboardUrl] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [learningOpen, setLearningOpen] = useState(false);

  const [hasCx, setHasCx] = useState(false);

useEffect(() => {
  if (cx === "yes") {
    setHasCx(true);
  }
}, [cx]);


  useEffect(() => {
    if (!company_id || !role) return;

    const fetchDashboards = async () => {
      try {
        const response = await fetch(`${API_BASE}/dashboards-by-access`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ company_id, role, client_name, director, state }),
        });

        const dashboards = await response.json();
        setDashboardLinks(dashboards);

        if (dashboards.length > 0) {
          setSelectedDashboardUrl(dashboards[2].iframe_url);
        }
      } catch (error) {
        console.error("Failed to fetch dashboards:", error);
      }
    };

    fetchDashboards();
  }, [company_id, role, client_name, director, state, token]);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
    <aside
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
      className={`${
        collapsed ? "w-20" : "w-64"
      } relative text-white transition-all duration-300 flex flex-col shadow-lg bg-repeat bg-center bg-[length:500px_500px]`}
      style={{ backgroundImage: "url('/vintage-phone-pattern.png')" }}
    >

        {/* Overlay tint */}
        <div className="absolute inset-0 bg-[#179D68]/80 z-0" />

        <div className="flex items-center justify-between px-4 py-4 border-b border-white/20 relative z-10">
          {!collapsed ? (
            <div className="flex items-center gap-3 text-xl font-bold tracking-wide">
              <img
                src={logo}
                alt="Dead Ringers Logo"
                className="h-10 w-10 rounded-md shadow-md border border-white/20 object-contain bg-white p-1"
              />
              Dead Ringers
            </div>
          ) : (
            <img
              src={logo}
              alt="Dead Ringers Logo"
              className="h-10 w-10 rounded-md shadow-md border border-white/20 object-contain bg-white p-1"
            />
          )}
          <button
            onClick={() => setCollapsed(!collapsed)}
            className="text-white/80 hover:bg-white/20 p-2 rounded"
          >
            {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </button>
        </div>

        <div className="flex flex-col justify-between h-full flex-grow relative z-10">
          <div>
            <div className="mt-6 px-4">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full flex items-center justify-between px-4 py-3 bg-white/10 hover:bg-white/20 text-white font-bold text-base rounded-lg shadow transition"
              >
                <div className="flex items-center gap-2">
                  <FaChartBar className="text-white text-lg" />
                  {!collapsed && "Dashboards"}
                </div>
                {!collapsed && (
                  <span className="text-white/80 text-sm">{dropdownOpen ? "▲" : "▼"}</span>
                )}
              </button>

              {!collapsed && dropdownOpen && (
                <div className="mt-1">
                  {dashboardLinks.map((dash, idx) => (
                    <button
                      key={idx}
                      onClick={() => setSelectedDashboardUrl(dash.iframe_url)}
                      className="w-full text-left px-6 py-2 text-sm transition font-medium tracking-wide hover:bg-white/10 text-white truncate"
                      style={{
                        fontFamily: "'Inter', 'Segoe UI', sans-serif",
                        fontSize: "15px",
                        lineHeight: "1.6",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "100%",
                      }}
                    >
                      {dash.dashboard_name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>


          {/* RESOURCES Menu */}
<div className="mt-4 px-4">
  <button
    onClick={() => setResourcesOpen(prev => !prev)}
    className="w-full flex items-center justify-between px-4 py-3 bg-white/10 hover:bg-white/20 text-white font-bold text-base rounded-lg shadow transition"
  >
    <div className="flex items-center gap-2">
      <FaBookOpen className="text-white text-lg" />
      {!collapsed && "Resources"}
    </div>
    {!collapsed && (
      <span className="text-white/80 text-sm">{resourcesOpen ? "▲" : "▼"}</span>
    )}
  </button>

  {!collapsed && resourcesOpen && (
    <div className="mt-1">
      {[

        {
          name: "Call Excellence Guide",
          url: "https://www.vivbi.com/wp-content/uploads/2025/07/Call-Excellence-Guide-AtNeed.pdf",
        },

        {
          name: "Certification Checklist",
          url: "https://www.vivbi.com/wp-content/uploads/2025/07/Dead-Ringers-Certification-Checklist.pdf",
        },
        {
          name: "FTC Glossary",
          url: "https://www.vivbi.com/wp-content/uploads/2025/07/DeadRingers-FTC-Glossary.pdf",
        },
        {
          name: "Price Shopper Guide",
          url: "https://www.vivbi.com/wp-content/uploads/2025/07/Price-Shopper-Guide.pdf",
        },
        {
          name: "Telephone Etiquette",
          url: "https://www.vivbi.com/wp-content/uploads/2025/07/10TenetsofTelephoneEtiquette-Full.pdf",
        },
      ].map((res, idx) => (
        <a
          key={idx}
          href={res.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-left px-6 py-2 text-sm transition font-medium tracking-wide hover:bg-white/10 text-white truncate"
          style={{
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
            fontSize: "15px",
            lineHeight: "1.6",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
        >
          {res.name}
        </a>
      ))}
    </div>
  )}
</div>


{/* CXpertise Menu */}
{hasCx  && (
  <div className="mt-4 px-4">
    <button
      onClick={() => setLearningOpen(prev => !prev)}
      className="w-full flex items-center justify-between px-4 py-3 bg-white/10 hover:bg-white/20 text-white font-bold text-base rounded-lg shadow transition"
    >
      <div className="flex items-center gap-2">
        <FaGraduationCap className="text-white text-lg" />
        {!collapsed && "CXpertise"}
      </div>
      {!collapsed && (
        <span className="text-white/80 text-sm">{learningOpen ? "▲" : "▼"}</span>
      )}
    </button>

    {!collapsed && learningOpen && (
      <div className="mt-1">
        <a
          href="https://cxpertise.thinkific.com/pages/journeys"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-left px-6 py-2 text-sm transition font-medium tracking-wide hover:bg-white/10 text-white truncate"
          style={{
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
            fontSize: "15px",
            lineHeight: "1.6",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
        >
          Learning Platform
        </a>
      </div>
    )}
  </div>
)}


          <div className="mt-auto px-4 py-4 border-t border-white/20 text-xs text-white/70">
            {role === "Admin" && (
              <button
                onClick={() => navigate("/admin")}
                className="flex items-center gap-2 text-white hover:bg-white/10 p-2 rounded w-full text-left mb-2"
              >
                <Settings size={18} />
                {!collapsed && <span>Admin</span>}
              </button>
            )}

            {!collapsed && (
              <div className="mb-2">
                Logged in as:
                <div className="text-white font-medium">{userEmail}</div>
              </div>
            )}
            <button
              onClick={onLogout}
              className="w-full bg-white text-[#179D68] font-semibold px-4 py-2 mt-2 rounded hover:bg-gray-100 text-sm flex items-center justify-center gap-2"
            >
              <LogOut size={16} />
              {!collapsed && "Logout"}
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 bg-[#f1f1f1] overflow-hidden">
        {selectedDashboardUrl ? (
          <iframe
            src={selectedDashboardUrl}
            title="Dashboard"
            className="w-full h-screen border-0"
            frameBorder="0"
            allowTransparency="true"
          />
        ) : (
          <div className="p-6 text-gray-500 text-sm">Loading Dashboards...</div>
        )}
      </main>
    </div>
  );
}

export default Dashboard;
